'use client';

import * as SwitchPrimitive from '@radix-ui/react-switch';
import * as React from 'react';

import { cn } from '../../lib/utils';

function Switch({
  className,
  ...props
}: React.ComponentProps<typeof SwitchPrimitive.Root>) {
  return (
    <SwitchPrimitive.Root
      data-slot="switch"
      className={cn(
        'peer inline-flex h-[26px] max-h-[26px] w-[50px] max-w-[50px] shrink-0 cursor-pointer items-center rounded-full border border-transparent px-4xs py-[3px] shadow-xs transition-all outline-none',
        'data-[state=unchecked]:bg-comp-switch-unchecked-bg-default data-[state=unchecked]:hover:bg-comp-switch-unchecked-bg-hover data-[state=unchecked]:active:bg-comp-switch-unchecked-bg-active',
        'data-[state=checked]:bg-comp-switch-checked-bg-default data-[state=checked]:hover:bg-comp-switch-checked-bg-hover data-[state=checked]:active:bg-comp-switch-checked-bg-active',
        'disabled:cursor-not-allowed',
        'data-[state=checked]:disabled:bg-comp-switch-checked-bg-disabled',
        'data-[state=unchecked]:disabled:bg-comp-switch-unchecked-bg-disabled',
        className,
      )}
      {...props}
    >
      <SwitchPrimitive.Thumb
        data-slot="switch-thumb"
        className={cn(
          'pointer-events-none block size-[20px] rounded-full bg-comp-switch-thumb-bg ring-0 inset-shadow-thick-sm transition-all',
          'data-[state=checked]:translate-x-[calc(100%)] data-[state=unchecked]:translate-x-0',
          'min-h-[16px] min-w-[16px]',
          'data-[state=unchecked]:data-[disabled]:bg-comp-switch-thumb-bg-disabled',
        )}
      />
    </SwitchPrimitive.Root>
  );
}

export { Switch as RadixSwitch };
